// extracted by mini-css-extract-plugin
export default {"container":"Compliance_container__WTw0x"};